import {createSlice} from "@reduxjs/toolkit";
import {deleteCurrencySuccess, updateCurrencySuccess} from "./currencySlice";


const initialState = {
    categories: []
}

const categorySlice = createSlice({
    name: 'category',
    initialState: initialState,
    reducers: {
        loadCategoriesSuccess(state, action) {
            return {...state, categories: action.payload}
        },
        updateCategorySuccess(state, action) {
            const savedCategory = action.payload;
            const categories = [...state.categories];
            let updated = false;

            categories.forEach((category, index) => {
                if (category.id === savedCategory.id) {
                    categories[index] = savedCategory;
                    updated = true;
                }
            });
            if (!updated) {
                categories.push(savedCategory);
            }
            return {...state, categories: categories}
        },
        // deleteCategorySuccess(state, action) {
        //     const id = action.payload;
        //     const categories = state.categories.filter(category => category.id != id);
        //     return {...state, categories: categories}
        // }
    }
})

export const {loadCategoriesSuccess, updateCategorySuccess, deleteCategorySuccess} = categorySlice.actions
export default categorySlice.reducer


export const fetchCategories = () => async (dispatch, getState) => {
    if(getState().categorySlice.categories.length > 0) {
        return;
    }
    fetch('/api/categories')
        .then((response) => {
            if (response.ok) {
                response.json().then(json =>
                    dispatch(loadCategoriesSuccess(json)));
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const saveCategory = (category, onSuccess) => async (dispatch, getState) => {

    fetch('/api/categories', {
        method: "PUT",
        body: JSON.stringify(category),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(updateCategorySuccess(json));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const deleteCategory = (category, onSuccess) => async (dispatch, getState) => {
    fetch('/api/categories?id=' + category.id, {
        method: "DELETE"
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    const savedCategory = {...category}
                    savedCategory.state = "DELETED";
                    dispatch(updateCategorySuccess(savedCategory));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const selectCategories = (state) => {
    return state.categorySlice.categories;
}

export const selectCategory = (categoryId) => (state) =>
    state.categorySlice.categories ? state.categorySlice.categories.find(category => category.id === categoryId) : undefined;

